// import jobServices from 'ApiService/Admin/jobServices';
// import Card from 'components/card';
// import InputField from 'components/fields/InputField';
// import TextField from 'components/fields/TextField';
// import ConfirmationModal from 'pages/Common/ConfirmationModal';
// import Nodatafound from 'pages/Common/Nodatafound';
// import { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import { BallTriangle } from 'react-loader-spinner';
// import PlacementStatusButton from './PlacementStatusButton';

// const AttendancesSheet = ({
//   classData,
//   attendance,
//   getStudents,
//   onStudentPause,
//   currentStep,
//   disable,
//   handleNext,
//   handleBack,
// }) => {
//   const [loading, setLoading] = useState(true);
//   const [showPauseModal, setShowPauseModal] = useState(false);
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [studentPauseStatuses, setStudentPauseStatuses] = useState({});
//   const [loadingStatus, setLoadingStatus] = useState(true);
//   const [isPermanentPause, setIsPermanentPause] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredAttendance, setFilteredAttendance] = useState([]);
//   const [showConfirmation, setShowConfirmation] = useState(false);
//   const [pauseDetails, setPauseDetails] = useState({
//     startDate: '',
//     endDate: '',
//     reason: '',
//   });
//   const [showUnpauseModal, setShowUnpauseModal] = useState(false);
//   const [unpauseReason, setUnpauseReason] = useState('');
//   const [confirmationLoading, setConfirmationLoading] = useState(false);
//   useEffect(() => {
//     if (classData) {
//       setLoading(true);
//       getStudents().finally(() => setLoading(false));
//     }
//   }, [classData]);
//   useEffect(() => {
//     setFilteredAttendance(
//       attendance.filter((student) =>
//         student.name.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//   }, [searchTerm, attendance]);

//   useEffect(() => {
//     const fetchAllStudentsPauseStatus = async () => {
//       setLoadingStatus(true);
//       try {
//         const studentIds = attendance.map((student) => student.id);
//         const response = await jobServices.getAllStudentsPauseStatus(
//           studentIds
//         );

//         if (response.data.success) {
//           const statusMap = response.data.pauseStatuses.reduce(
//             (acc, status) => {
//               acc[status.studentId] = status;
//               return acc;
//             },
//             {}
//           );
//           setStudentPauseStatuses(statusMap);
//         }
//       } catch (error) {
//         toast.error('Failed to fetch student pause statuses');
//       } finally {
//         setLoadingStatus(false);
//       }
//     };

//     if (attendance.length > 0) {
//       fetchAllStudentsPauseStatus();
//     }
//   }, [attendance]);

//   const preparePausePlacement = () => {
//     if (confirmationLoading) return;
//     if (
//       !isPermanentPause &&
//       (!pauseDetails.startDate || !pauseDetails.endDate)
//     ) {
//       toast.error('Please fill in the required dates.');
//       return;
//     }

//     if (!pauseDetails.reason) {
//       toast.error('Please provide a reason for the pause.');
//       return;
//     }

//     if (!selectedStudent) {
//       toast.error('No student selected for pause.');
//       return;
//     }

//     setShowConfirmation(true);
//   };

//   const handlePausePlacement = async () => {
//     if (confirmationLoading) return;
//     setConfirmationLoading(true);
//     setLoadingStatus(true);

//     if (
//       !isPermanentPause &&
//       (!pauseDetails.startDate || !pauseDetails.endDate)
//     ) {
//       toast.error('Please fill in the required dates.');
//       setConfirmationLoading(false);
//       return;
//     }

//     if (!pauseDetails.reason) {
//       toast.error('Please provide a reason for the pause.');
//       setConfirmationLoading(false);
//       return;
//     }

//     if (!selectedStudent) {
//       toast.error('No student selected for pause.');
//       setConfirmationLoading(false);
//       return;
//     }

//     try {
//       const studentPauseDetails = {
//         ...pauseDetails,
//         studentId: selectedStudent.id,
//         isPermanent: isPermanentPause,
//       };

//       const result = await onStudentPause(studentPauseDetails);

//       if (result.success) {
//         toast.success(
//           `Placement ${isPermanentPause ? 'permanently ' : ''}paused for ${
//             selectedStudent.name
//           }`
//         );
//         setShowPauseModal(false);
//         setShowConfirmation(false);
//         setPauseDetails({ startDate: '', endDate: '', reason: '' });
//         setIsPermanentPause(false);
//         setSelectedStudent(null);
//         getStudents();
//       } else {
//         toast.error(result.message || 'Failed to pause placement');
//       }
//     } catch (error) {
//       toast.error('Failed to pause placement');
//     } finally {
//       setConfirmationLoading(false); // Reset flag after request completes
//       setLoadingStatus(false);
//     }
//   };

//   const handleUnpausePlacement = async (studentId) => {
//     setLoadingStatus(true);

//     try {
//       const response = await jobServices.unpausePlacement(studentId);
//       if (response.data.success) {
//         toast.success('Placement unpaused successfully.');
//         getStudents();
//       } else {
//         toast.error(response?.data?.message || 'Failed to unpause placement');
//       }
//     } catch (error) {
//       toast.error(
//         error.response?.data?.message || 'Failed to unpause placement'
//       );
//     } finally {
//       setLoadingStatus(false);
//     }
//   };

//   const closeModals = () => {
//     setShowPauseModal(false);
//     setSelectedStudent(null);
//     setIsPermanentPause(false);
//     setPauseDetails({ startDate: '', endDate: '', reason: '' });
//     setShowConfirmation(false);
//   };

//   const closeUnpauseModal = () => {
//     setShowUnpauseModal(false);
//     setSelectedStudent(null);
//     setUnpauseReason('');
//   };

//   const handleRequestUnpausePlacement = (student) => {
//     setSelectedStudent(student);
//     setUnpauseReason('');
//     setShowUnpauseModal(true);
//   };

//   const submitUnpauseRequest = async () => {
//     setConfirmationLoading(true);

//     if (!unpauseReason.trim()) {
//       toast.error('Please provide a reason for unpausing placement');
//       setConfirmationLoading(false);
//       return;
//     }

//     try {
//       const response = await jobServices.requestUnpausePlacement(
//         selectedStudent.id,
//         unpauseReason.trim()
//       );

//       if (response.data.success) {
//         toast.success(response.data.message);

//         getStudents();

//         setShowUnpauseModal(false);
//         setSelectedStudent(null);
//         setUnpauseReason('');
//       } else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || 'Failed to submit unpause request'
//       );
//     } finally {
//       setConfirmationLoading(false);
//     }
//   };

//   return (
//     <Card extra="w-full sm:overflow-auto p-4">
//       <div className="mb-4">
//         {currentStep === 1 ? (
//           <div className="mb-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
//             <button
//               disabled={disable}
//               onClick={handleNext}
//               className=" linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
//             >
//               {loading ? 'Loading..' : 'Next'}
//             </button>
//           </div>
//         ) : (
//           <div className="flex flex-col justify-end px-3 pt-2  md:flex-row md:px-8">
//             <button
//               onClick={handleBack}
//               className={`mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mb-0`}
//             >
//               Prev
//             </button>
//           </div>
//         )}
//         <InputField
//           label="Search by Name"
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Enter student name..."
//         />
//       </div>
//       <div>
//         {loading ? (
//           <div className="flex h-64 items-center justify-center">
//             <BallTriangle color="#5431ed" />
//           </div>
//         ) : filteredAttendance.length ? (
//           <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
//             <table className="w-full">
//               <thead className="w-full">
//                 <tr className="border-b border-gray-200 dark:border-white/10">
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">SR.NO</div>
//                   </th>
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">NAME</div>
//                   </th>
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">STATUS</div>
//                   </th>
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">ACTIONS</div>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredAttendance.map((student, index) => {
//                   const pauseStatus = studentPauseStatuses[student.id] || {};
//                   const isPlacementPausedOverall =
//                     pauseStatus.isPlacementPaused ||
//                     pauseStatus.isPlacementPausedByAdmin;
//                   const isPermanentPause = pauseStatus.pauseInfo?.isPermanent;
//                   const studentStatus = pauseStatus.status || 'none';

//                   return (
//                     <tr
//                       key={student.id}
//                       className="border-b border-gray-200 dark:border-white/10"
//                     >
//                       <td className="px-[27px] py-[16px] text-center text-navy-700 dark:text-white">
//                         {index + 1}
//                       </td>
//                       <td className="px-[27px] py-[16px] text-center text-navy-700 dark:text-white">
//                         {student.name}
//                       </td>
//                       <td className="px-[27px] py-[16px] text-center text-navy-700 dark:text-white">
//                         {isPermanentPause ? (
//                           <span className="font-medium text-red-500">
//                             Permanently Paused
//                           </span>
//                         ) : isPlacementPausedOverall ? (
//                           <span className="font-medium text-yellow-500">
//                             Temporarily Paused
//                           </span>
//                         ) : (
//                           <span className="font-medium text-green-500">
//                             Active
//                           </span>
//                         )}
//                       </td>

//                       <td className="px-[27px] py-[16px] text-center">
//                         <PlacementStatusButton
//                           student={student}
//                           loadingStatus={loadingStatus}
//                           isPlacementPausedOverall={isPlacementPausedOverall}
//                           handleUnpausePlacement={handleUnpausePlacement}
//                           setSelectedStudent={setSelectedStudent}
//                           setShowPauseModal={setShowPauseModal}
//                           pauseInfo={pauseStatus.pauseInfo}
//                           status={pauseStatus.status}
//                           getStudents={getStudents}
//                         />
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <Nodatafound title="No matching attendance data found." />
//         )}
//       </div>

//       {showPauseModal && (
//         <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50 p-2">
//           <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-800">
//             <button
//               onClick={closeModals}
//               className="absolute right-2 top-2 text-2xl text-gray-500 hover:text-gray-700"
//             >
//               &times;
//             </button>
//             <h2 className="mb-4 text-lg font-semibold">
//               Pause Placement for {selectedStudent?.name}
//             </h2>

//             <div className="mb-4">
//               <label className="flex items-center space-x-2">
//                 <input
//                   type="checkbox"
//                   checked={isPermanentPause}
//                   onChange={(e) => setIsPermanentPause(e.target.checked)}
//                   className="h-4 w-4 rounded border-gray-300"
//                 />
//                 <span className="text-sm">Permanent Pause</span>
//               </label>
//             </div>

//             {!isPermanentPause && (
//               <>
//                 <InputField
//                   label="Start Date"
//                   type="date"
//                   value={pauseDetails.startDate}
//                   onChange={(e) =>
//                     setPauseDetails({
//                       ...pauseDetails,
//                       startDate: e.target.value,
//                     })
//                   }
//                 />
//                 <InputField
//                   label="End Date"
//                   type="date"
//                   value={pauseDetails.endDate}
//                   min={pauseDetails.startDate}
//                   onChange={(e) =>
//                     setPauseDetails({
//                       ...pauseDetails,
//                       endDate: e.target.value,
//                     })
//                   }
//                 />
//               </>
//             )}

//             <TextField
//               label="Reason"
//               value={pauseDetails.reason}
//               onChange={(e) =>
//                 setPauseDetails({ ...pauseDetails, reason: e.target.value })
//               }
//             />
//             <button
//               onClick={preparePausePlacement}
//               disabled={confirmationLoading}
//               className={`w-40 rounded-xl bg-brand-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 ${
//                 confirmationLoading
//                   ? 'cursor-not-allowed opacity-50'
//                   : 'hover:bg-brand-600 active:bg-brand-700'
//               } dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`}
//             >
//               {confirmationLoading
//                 ? 'Processing...'
//                 : isPermanentPause
//                 ? 'Permanently Pause'
//                 : 'Pause'}
//             </button>

//             {/* <div className="mt-5 flex justify-end">
//               <button
//                 onClick={preparePausePlacement}
//                 className="w-40 rounded-xl bg-brand-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
//               >
//                 {isPermanentPause ? 'Permanently Pause' : 'Pause'}
//               </button>
//             </div> */}
//           </div>
//         </div>
//       )}

//       {showUnpauseModal && (
//         <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50 p-2">
//           <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-800">
//             <button
//               onClick={closeUnpauseModal}
//               className="absolute right-2 top-2 text-2xl text-gray-500 hover:text-gray-700"
//             >
//               &times;
//             </button>
//             <h2 className="mb-4 text-lg font-semibold">
//               Request Unpause for {selectedStudent?.name}
//             </h2>

//             <TextField
//               label="Reason for Unpause"
//               value={unpauseReason}
//               onChange={(e) => setUnpauseReason(e.target.value)}
//               placeholder="Enter reason for requesting unpause"
//             />

//             <div className="mt-5 flex justify-end">
//               <button
//                 onClick={submitUnpauseRequest}
//                 disabled={confirmationLoading}
//                 className="w-40 rounded-xl bg-green-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-green-600 active:bg-green-700"
//               >
//                 {confirmationLoading ? 'Submitting...' : 'Submit Request'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showUnpauseModal && (
//         <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50 p-2">
//           <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-800">
//             <button
//               onClick={closeUnpauseModal}
//               className="absolute right-2 top-2 text-2xl text-gray-500 hover:text-gray-700"
//             >
//               &times;
//             </button>
//             <h2 className="mb-4 text-lg font-semibold">
//               Request Unpause for {selectedStudent?.name}
//             </h2>

//             <TextField
//               label="Reason for Unpause"
//               value={unpauseReason}
//               onChange={(e) => setUnpauseReason(e.target.value)}
//               placeholder="Enter reason for requesting unpause"
//             />

//             <div className="mt-5 flex justify-end">
//               <button
//                 onClick={submitUnpauseRequest}
//                 disabled={confirmationLoading}
//                 className="w-40 rounded-xl bg-green-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-green-600 active:bg-green-700"
//               >
//                 {confirmationLoading ? 'Submitting...' : 'Submit Request'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <ConfirmationModal
//         isOpen={showConfirmation}
//         onClose={() => setShowConfirmation(false)}
//         onConfirm={handlePausePlacement}
//         title={`Confirm ${isPermanentPause ? 'Permanent' : 'Temporary'} Pause`}
//         message={`Are you sure you want to ${
//           isPermanentPause ? 'permanently' : 'temporarily'
//         } pause placement for ${selectedStudent?.name}?`}
//         confirmText="Yes, Pause Placement"
//         cancelText="Cancel"
//         icon="warning"
//         disableConfirm={confirmationLoading}
//       />
//     </Card>
//   );
// };

// export default AttendancesSheet;

import jobServices from 'ApiService/Admin/jobServices';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import TextField from 'components/fields/TextField';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import Nodatafound from 'pages/Common/Nodatafound';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import PlacementStatusButton from './PlacementStatusButton';

const AttendancesSheet = ({
  classData,
  attendance,
  getStudents,
  onStudentPause,
  currentStep,
  disable,
  handleNext,
  handleBack,
}) => {
  const [loading, setLoading] = useState(false);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentPauseStatuses, setStudentPauseStatuses] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(true);
  const [isPermanentPause, setIsPermanentPause] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredAttendance, setFilteredAttendance] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [pauseDetails, setPauseDetails] = useState({
    startDate: '',
    endDate: '',
    reason: '',
  });
  const [showUnpauseModal, setShowUnpauseModal] = useState(false);
  const [unpauseReason, setUnpauseReason] = useState('');
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  useEffect(() => {
    if (attendance.length >= 0) {
      setLoading(false);
    }
  }, [attendance]);

  useEffect(() => {
    setFilteredAttendance(
      attendance.filter((student) =>
        student.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, attendance]);

  useEffect(() => {
    const fetchAllStudentsPauseStatus = async () => {
      setLoadingStatus(true);
      try {
        const studentIds = attendance.map((student) => student.id);
        const response = await jobServices.getAllStudentsPauseStatus(
          studentIds
        );

        if (response.data.success) {
          const statusMap = response.data.pauseStatuses.reduce(
            (acc, status) => {
              acc[status.studentId] = status;
              return acc;
            },
            {}
          );
          setStudentPauseStatuses(statusMap);
        }
      } catch (error) {
        toast.error('Failed to fetch student pause statuses');
      } finally {
        setLoadingStatus(false);
      }
    };

    if (attendance.length > 0) {
      fetchAllStudentsPauseStatus();
    }
  }, [attendance]);

  const preparePausePlacement = () => {
    if (confirmationLoading) return;
    if (
      !isPermanentPause &&
      (!pauseDetails.startDate || !pauseDetails.endDate)
    ) {
      toast.error('Please fill in the required dates.');
      return;
    }

    if (!pauseDetails.reason) {
      toast.error('Please provide a reason for the pause.');
      return;
    }

    if (!selectedStudent) {
      toast.error('No student selected for pause.');
      return;
    }

    setShowConfirmation(true);
  };

  const handlePausePlacement = async () => {
    if (confirmationLoading) return;
    setConfirmationLoading(true);
    setLoadingStatus(true);

    if (
      !isPermanentPause &&
      (!pauseDetails.startDate || !pauseDetails.endDate)
    ) {
      toast.error('Please fill in the required dates.');
      setConfirmationLoading(false);
      return;
    }

    if (!pauseDetails.reason) {
      toast.error('Please provide a reason for the pause.');
      setConfirmationLoading(false);
      return;
    }

    if (!selectedStudent) {
      toast.error('No student selected for pause.');
      setConfirmationLoading(false);
      return;
    }

    try {
      const studentPauseDetails = {
        ...pauseDetails,
        studentId: selectedStudent.id,
        isPermanent: isPermanentPause,
      };

      const result = await onStudentPause(studentPauseDetails);

      if (result.success) {
        toast.success(
          `Placement ${isPermanentPause ? 'permanently ' : ''}paused for ${
            selectedStudent.name
          }`
        );
        setShowPauseModal(false);
        setShowConfirmation(false);
        setPauseDetails({ startDate: '', endDate: '', reason: '' });
        setIsPermanentPause(false);
        setSelectedStudent(null);
        getStudents();
      } else {
        toast.error(result.message || 'Failed to pause placement');
      }
    } catch (error) {
      toast.error('Failed to pause placement');
    } finally {
      setConfirmationLoading(false); // Reset flag after request completes
      setLoadingStatus(false);
    }
  };

  const handleUnpausePlacement = async (studentId) => {
    setLoadingStatus(true);

    try {
      const response = await jobServices.unpausePlacement(studentId);
      if (response.data.success) {
        toast.success('Placement unpaused successfully.');
        getStudents();
      } else {
        toast.error(response?.data?.message || 'Failed to unpause placement');
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Failed to unpause placement'
      );
    } finally {
      setLoadingStatus(false);
    }
  };

  const closeModals = () => {
    setShowPauseModal(false);
    setSelectedStudent(null);
    setIsPermanentPause(false);
    setPauseDetails({ startDate: '', endDate: '', reason: '' });
    setShowConfirmation(false);
  };

  const closeUnpauseModal = () => {
    setShowUnpauseModal(false);
    setSelectedStudent(null);
    setUnpauseReason('');
  };

  const handleRequestUnpausePlacement = (student) => {
    setSelectedStudent(student);
    setUnpauseReason('');
    setShowUnpauseModal(true);
  };

  const submitUnpauseRequest = async () => {
    setConfirmationLoading(true);

    if (!unpauseReason.trim()) {
      toast.error('Please provide a reason for unpausing placement');
      setConfirmationLoading(false);
      return;
    }

    try {
      const response = await jobServices.requestUnpausePlacement(
        selectedStudent.id,
        unpauseReason.trim()
      );

      if (response.data.success) {
        toast.success(response.data.message);

        getStudents();

        setShowUnpauseModal(false);
        setSelectedStudent(null);
        setUnpauseReason('');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to submit unpause request'
      );
    } finally {
      setConfirmationLoading(false);
    }
  };

  return (
    <Card extra="w-full sm:overflow-auto p-4">
      <div className="mb-4">
        {currentStep === 1 ? (
          <div className="mb-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            <button
              disabled={disable}
              onClick={handleNext}
              className=" linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
            >
              {loading ? 'Loading..' : 'Next'}
            </button>
          </div>
        ) : (
          <div className="flex flex-col justify-end px-3 pt-2  md:flex-row md:px-8">
            <button
              onClick={handleBack}
              className={`mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mb-0`}
            >
              Prev
            </button>
          </div>
        )}
        <InputField
          label="Search by Name"
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Enter student name..."
        />
      </div>
      <div>
        {loading ? (
          <div className="flex h-64 items-center justify-center">
            <BallTriangle color="#5431ed" />
          </div>
        ) : filteredAttendance.length ? (
          <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
            <table className="w-full">
              <thead className="w-full">
                <tr className="border-b border-gray-200 dark:border-white/10">
                  <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">SR.NO</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">NAME</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">STATUS</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">ACTIONS</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredAttendance.map((student, index) => {
                  const pauseStatus = studentPauseStatuses[student.id] || {};
                  const isPlacementPausedOverall =
                    pauseStatus.isPlacementPaused ||
                    pauseStatus.isPlacementPausedByAdmin;
                  const isPermanentPause = pauseStatus.pauseInfo?.isPermanent;
                  const studentStatus = pauseStatus.status || 'none';

                  return (
                    <tr
                      key={student.id}
                      className="border-b border-gray-200 dark:border-white/10"
                    >
                      <td className="px-[27px] py-[16px] text-center text-navy-700 dark:text-white">
                        {index + 1}
                      </td>
                      <td className="px-[27px] py-[16px] text-center text-navy-700 dark:text-white">
                        {student.name}
                      </td>
                      <td className="px-[27px] py-[16px] text-center text-navy-700 dark:text-white">
                        {isPermanentPause ? (
                          <span className="font-medium text-red-500">
                            Permanently Paused
                          </span>
                        ) : isPlacementPausedOverall ? (
                          <span className="font-medium text-yellow-500">
                            Temporarily Paused
                          </span>
                        ) : (
                          <span className="font-medium text-green-500">
                            Active
                          </span>
                        )}
                      </td>

                      <td className="px-[27px] py-[16px] text-center">
                        <PlacementStatusButton
                          student={student}
                          loadingStatus={loadingStatus}
                          isPlacementPausedOverall={isPlacementPausedOverall}
                          handleUnpausePlacement={handleUnpausePlacement}
                          setSelectedStudent={setSelectedStudent}
                          setShowPauseModal={setShowPauseModal}
                          pauseInfo={pauseStatus.pauseInfo}
                          status={pauseStatus.status}
                          getStudents={getStudents}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <Nodatafound title="No matching attendance data found." />
        )}
      </div>

      {showPauseModal && (
        <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50 p-2">
          <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-800">
            <button
              onClick={closeModals}
              className="absolute right-2 top-2 text-2xl text-gray-500 hover:text-gray-700"
            >
              &times;
            </button>
            <h2 className="mb-4 text-lg font-semibold">
              Pause Placement for {selectedStudent?.name}
            </h2>

            <div className="mb-4">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={isPermanentPause}
                  onChange={(e) => setIsPermanentPause(e.target.checked)}
                  className="h-4 w-4 rounded border-gray-300"
                />
                <span className="text-sm">Permanent Pause</span>
              </label>
            </div>

            {!isPermanentPause && (
              <>
                <InputField
                  label="Start Date"
                  type="date"
                  value={pauseDetails.startDate}
                  onChange={(e) =>
                    setPauseDetails({
                      ...pauseDetails,
                      startDate: e.target.value,
                    })
                  }
                />
                <InputField
                  label="End Date"
                  type="date"
                  value={pauseDetails.endDate}
                  min={pauseDetails.startDate}
                  onChange={(e) =>
                    setPauseDetails({
                      ...pauseDetails,
                      endDate: e.target.value,
                    })
                  }
                />
              </>
            )}

            <TextField
              label="Reason"
              value={pauseDetails.reason}
              onChange={(e) =>
                setPauseDetails({ ...pauseDetails, reason: e.target.value })
              }
            />
            <button
              onClick={preparePausePlacement}
              disabled={confirmationLoading}
              className={`w-40 rounded-xl bg-brand-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 ${
                confirmationLoading
                  ? 'cursor-not-allowed opacity-50'
                  : 'hover:bg-brand-600 active:bg-brand-700'
              } dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`}
            >
              {confirmationLoading
                ? 'Processing...'
                : isPermanentPause
                ? 'Permanently Pause'
                : 'Pause'}
            </button>

            {/* <div className="mt-5 flex justify-end">
              <button
                onClick={preparePausePlacement}
                className="w-40 rounded-xl bg-brand-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
              >
                {isPermanentPause ? 'Permanently Pause' : 'Pause'}
              </button>
            </div> */}
          </div>
        </div>
      )}

      {showUnpauseModal && (
        <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50 p-2">
          <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-800">
            <button
              onClick={closeUnpauseModal}
              className="absolute right-2 top-2 text-2xl text-gray-500 hover:text-gray-700"
            >
              &times;
            </button>
            <h2 className="mb-4 text-lg font-semibold">
              Request Unpause for {selectedStudent?.name}
            </h2>

            <TextField
              label="Reason for Unpause"
              value={unpauseReason}
              onChange={(e) => setUnpauseReason(e.target.value)}
              placeholder="Enter reason for requesting unpause"
            />

            <div className="mt-5 flex justify-end">
              <button
                onClick={submitUnpauseRequest}
                disabled={confirmationLoading}
                className="w-40 rounded-xl bg-green-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-green-600 active:bg-green-700"
              >
                {confirmationLoading ? 'Submitting...' : 'Submit Request'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showUnpauseModal && (
        <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50 p-2">
          <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-800">
            <button
              onClick={closeUnpauseModal}
              className="absolute right-2 top-2 text-2xl text-gray-500 hover:text-gray-700"
            >
              &times;
            </button>
            <h2 className="mb-4 text-lg font-semibold">
              Request Unpause for {selectedStudent?.name}
            </h2>

            <TextField
              label="Reason for Unpause"
              value={unpauseReason}
              onChange={(e) => setUnpauseReason(e.target.value)}
              placeholder="Enter reason for requesting unpause"
            />

            <div className="mt-5 flex justify-end">
              <button
                onClick={submitUnpauseRequest}
                disabled={confirmationLoading}
                className="w-40 rounded-xl bg-green-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-green-600 active:bg-green-700"
              >
                {confirmationLoading ? 'Submitting...' : 'Submit Request'}
              </button>
            </div>
          </div>
        </div>
      )}

      <ConfirmationModal
        isOpen={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        onConfirm={handlePausePlacement}
        title={`Confirm ${isPermanentPause ? 'Permanent' : 'Temporary'} Pause`}
        message={`Are you sure you want to ${
          isPermanentPause ? 'permanently' : 'temporarily'
        } pause placement for ${selectedStudent?.name}?`}
        confirmText="Yes, Pause Placement"
        cancelText="Cancel"
        icon="warning"
        disableConfirm={confirmationLoading}
      />
    </Card>
  );
};

export default AttendancesSheet;
